<template>
    <div class="main-container">
        <!-- Navbar section -->
		<HeaderSingle />

        <div class="section-space-header bg-grey" id="pricing">
            <div class="pricing-table-title-area position-relative ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12  wow move-up">
                            <div class="section-title-wrapper text-center section-space--mb_60">
                                <h2 class="section-title font-weight--light mb-15">Personal Data Protection Act</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PolicyContent />

        <!-- footer section -->
        <FooterMain />
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css'
    import 'swiper/dist/css/swiper.css'
    import '@/assets/static-style/style.scss';
    import 'slick-carousel/slick/slick.css'

    import HeaderSingle from './components/sections/HeaderSingle.vue'
    import PolicyContent from './components/sections/PolicyContent.vue'
    import FooterMain from './components/FooterMain.vue'

    export default {
        name: 'app',
        components: {
            HeaderSingle,
            PolicyContent,
            FooterMain
        }
    }
</script>




<style lang="scss">
    @import '@/assets/static-style/_variabls.scss';
    @import '@/assets/scss/page-section/_payment.scss';
</style>

<style>
    .section-space-header {
        padding-top: 175px;
    }
    @media only screen and (max-width: 1199px) {
        .section-space-header {
            padding-top: 120px;
        }
    }
    @media only screen and (max-width: 767px) {
        .section-space-header {
            padding-top: 100px;
        }
    }
</style>